export default __webpack_public_path__ + "05536651407cd6810397d7d11f2da443.png";